module.exports = __webpack_public_path__ + "img/nentwichVerlag_logos_color_noFill.6d301d3b.svg";